import React from 'react';
import { Outlet } from 'react-router';

import { SYSTEM_ADMIN_PATH } from '../../../../constants';
const OrderRefund = React.lazy(() => import('./index'));

const Routes = {
     path: SYSTEM_ADMIN_PATH.ORDERS_REFUND,
     breadcrumb: 'Order Refund',
     element: <Outlet />,
     children: [{ index: true, element: <OrderRefund /> }],
};

export default Routes;
